// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"styles/variables.css\"","second-table-shrink-width":"1250px","fourth-table-shrink-width":"870px","linksSection":"LinksSection_linksSection__vk635"};